module.exports = __webpack_public_path__ + "assets/green-check.261a35b0.svg";